import { api } from '@/api';
import axios from 'axios';
import { API_URL } from '@/utils/static';

const getStatics = ({ languageId }) => {
  return axios.get(`${API_URL}/api/kyc/v1/project/schema?forSchema=STATICS`, {
    params: {
      languageId
    }
  });
};
const getStaticsAdmin = () => {
  return api.get('/api/kyc/v1/admin/project/schema?forSchema=STATICS');
};

const updateStatics = ({ id, text, text_RU, text_LV, file, type }) => {
  const formData = new FormData();
  if (file) formData.append('file', file);
  formData.append('componentSchemaId', id);
  if (text) formData.append('text', text);
  if (text_RU) formData.append('text_RU', text_RU);
  if (text_LV) formData.append('text_LV', text_LV);
  formData.append('type', type);

  return api.put('/api/kyc/v1/admin/project/schema', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const StaticsApi = {
  getStatics,
  getStaticsAdmin,
  updateStatics
};
